import { useContext } from "react";

import { HistoryContext } from "../context/HistoryContext";

import type { HistoryContextState } from "../context/HistoryContext";

// Custom hook to consume the context
export const usePreviousLocation = (): HistoryContextState => {
    const context = useContext(HistoryContext);
    if (!context) {
      throw new Error("usePreviousLocation must be used within a HistoryProvider");
    }
    return context;
  };